import React, { useEffect, useState } from 'react'
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import { HealthSystemSchema } from '../../../utils/validation'

const HealthSystemModal = ({ show, onClose, state, onSubmit }) => {
  const [showAlert, setShowAlert] = useState(false)

  const handleClose = () => {
    setShowAlert(false)
    onClose()
  }

  const createHealthSystem = useFormik({
    initialValues: {
      name: ''
    },
    enableReinitialize: true,
    validationSchema: HealthSystemSchema,
    onSubmit: (values) => {
      onSubmit(values)
    }
  })

  useEffect(() => {
    if (state.error !== false) {
      setShowAlert(true)
    }
  }, [state.error])

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header>
        <h4>Add Client</h4>
      </Modal.Header>
      <Form onSubmit={createHealthSystem.handleSubmit} noValidate id='form'>
        <Modal.Body>
          <Row>
            <Col xs={12}>
              <Alert show={showAlert} dismissible onClose={() => setShowAlert(false)} variant='danger'>
                {state.error.message ? state.error.message : (
                  <div dangerouslySetInnerHTML={{ __html: state.error }} />
                )}
              </Alert>
            </Col>
            <Form.Group as={Col} xs={12}>
              <Form.Label>
                Client Name
              </Form.Label>
              <Form.Control 
                id='name'
                name='name'
                type='text'
                onChange={createHealthSystem.handleChange}
                onBlur={createHealthSystem.handleBlur}
                isInvalid={!!createHealthSystem.errors.name && createHealthSystem.touched.name}
                placeholder='Client Name'
                values={createHealthSystem.values.name}
              />
              <Form.Control.Feedback type='invalid'>
                {createHealthSystem.errors.name}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-secondary' onClick={handleClose}>
            Cancel
          </Button>
          <Button type='submit' disabled={state.loading}>
            {
              state.loading ? <Spinner animation='border' role='status' size='sm' /> : 'Add'
            }
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

HealthSystemModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  state: PropTypes.shape({
    loading: PropTypes.bool,
    success: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        message: PropTypes.string
      }),
      PropTypes.string,
    ])
  })
}

export default HealthSystemModal